import { View } from '../../domain/View';
import { RulesKeys } from '../../domain/rules.keys';

export const initialState = {
  isReady: false,
  loading: false,
  dataConfList: new Map<RulesKeys, any>(),
  dataViewList: new Map<View, any>(),
};

export type RulesState = Readonly<typeof initialState>;
